import { gql } from "@apollo/client";

export const GET_TRIP_ANALYTICS_META = gql`
  query tripAnalytics($startDate: ISO8601Date!, $endDate: ISO8601Date!) {
    tripAnalytics(start: $startDate, finish: $endDate) {
      countries(first: 100) {
        totalCount
        nodes {
          name
          countryCode
        }
      }
    }
  }
`;

export const GET_TYPE_ENUMS = gql`
  fragment EnumValues on __Type {
    enumValues {
      name
      description
    }
  }
  query {
    MealCode: __type(name: "MealCode") {
      ...EnumValues
    }
    Transport: __type(name: "Transport") {
      ...EnumValues
    }
    Offer: __type(name: "Offer") {
      ...EnumValues
    }
  }
`;

export const GET_TRIP_ANALYTICS = gql`
  query tripAnalytics($startDate: ISO8601Date!, $endDate: ISO8601Date!) {
    tripAnalytics(start: $startDate, finish: $endDate) {
      minimumBasePrice
      averageBasePrice
      maximumBasePrice

      statsByCountry {
        countryCode
        minimumBasePrice
        averageBasePrice
        maximumBasePrice
      }

      statsByDepartureFrom {
        departureCity
        departureAirportCode
        minimumBasePrice
        averageBasePrice
        maximumBasePrice
      }

      statsByMeal {
        mealCode
        minimumBasePrice
        averageBasePrice
        maximumBasePrice
      }

      statsByPropertyCategory {
        propertyCategory
        minimumBasePrice
        averageBasePrice
        maximumBasePrice
      }

      statsByPropertyCategory {
        propertyCategory
        minimumBasePrice
        averageBasePrice
        maximumBasePrice
      }

      statsByTransportType {
        transportType
        minimumBasePrice
        averageBasePrice
        maximumBasePrice
      }

      statsByTripDuration {
        tripDuration
        minimumBasePrice
        averageBasePrice
        maximumBasePrice
      }
    }
  }
`;
